module.exports = __webpack_public_path__ + "4740cf11fe0ff331e625c1090930b66e.jpg";